import React, { useEffect } from 'react';

import useGlobal from '../../../../store';
import RenderItemStatus from './RenderItemStatus';
import Table from '../../../../facturotopia/table/Table';
import RenderItemResumenStatus from './RenderItemResumenStatus';

const mapState = (store) => {
  return store.modulo.autofacturacion.tickets;
};

const mapActions = (actions) => {
  return { ...actions.modulo.autofacturacion.tickets };
};

const AutofacturacionTicketList = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);
  const { busy, data } = state;

  useEffect(() => {
    if (data.length === 0) {
      const from = state.pagination.from;
      const to = state.pagination.to;

      actions.paginate({
        page: 1,
        from,
        to,
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const paginate = (meta) => {
    const { filters } = state;

    actions.paginate({
      ...filters,
      ...meta,
    });
  };

  const handleOnPageChange = (page) => {
    paginate({ page });
  };

  const handleOnPageLimitChange = (limit) => {
    paginate({ limit, page: 1 });
  };

  const getPaginationConfig = () => {
    const { pagination } = state;

    return {
      metadata: pagination,
      onPageChange: handleOnPageChange,
      onPageLimitChange: handleOnPageLimitChange,
    };
  };

  const setSelectedRows = (event) => {
    actions.setSelectedRows(event);

    !!props.onRowSelectionChange && props.onRowSelectionChange(event);
  };

  const getRowSelectionConfig = () => {
    const { selectedRowKeys = [] } = props;

    return {
      type: 'checkbox',
      selectedRowKeys,
      onChange: setSelectedRows,
      getCheckboxProps: (record) => ({
        name: record.name,
      }),
    };
  };

  const { onRowClick } = props;

  return (
    <Table
      loading={busy}
      columns={columns}
      rowKey={'id'}
      data={data}
      selectable={true}
      pagination={getPaginationConfig()}
      onRow={onRowRender}
      rowSelection={getRowSelectionConfig()}
      onRowClick={onRowClick}
    ></Table>
  );
};

const onRowRender = (item) => {
  return {
    className: item.highlight ? 'row-highlighted' : '',
  };
};

const columns = [
  {
    key: 'codigo',
    title: 'Código',
    dataIndex: 'codigo',
    className: 'cell-small',
  },
  {
    key: 'sucursal',
    title: 'Sucursal',
    dataIndex: 'sucursal',
    className: 'cell-small',
  },
  {
    key: 'fecha_servicio',
    title: 'Fecha servicio',
    dataIndex: 'fecha_servicio',
    className: 'cell-medium',
  },
  {
    key: 'created_at',
    title: 'Fecha',
    dataIndex: 'created_at',
    className: 'cell-medium',
  },
  {
    key: 'emisor_rfc',
    title: 'Emisor',
    dataIndex: 'emisor_rfc',
  },
  {
    key: 'receptor_rfc',
    title: 'Receptor',
    dataIndex: 'receptor_rfc',
  },
  {
    key: 'receptor_razon_social',
    title: 'Receptor nombre',
    dataIndex: 'receptor_razon_social',
    className: 'cell-large',
  },
  {
    key: 'forma_de_pago',
    title: 'Forma Pago',
    dataIndex: 'forma_de_pago',
    align: 'center',
  },
  {
    key: 'metodo_de_pago',
    title: 'Método Pago',
    dataIndex: 'metodo_de_pago',
    align: 'center',
  },
  {
    key: 'subtotal',
    title: 'Subtotal',
    dataIndex: 'subtotal',
    align: 'right',
  },
  {
    key: 'descuento',
    title: 'Descuento',
    dataIndex: 'descuento',
    align: 'right',
  },
  {
    key: 'total',
    title: 'Total',
    dataIndex: 'total',
    align: 'right',
  },
  {
    key: 'cfdi_uuid',
    title: 'Cfdi Uuid',
    dataIndex: 'cfdi_uuid',
    align: 'center',
    className: 'cell-xxlarge',
  },
  {
    key: 'status',
    title: 'Status',
    dataIndex: 'status',
    render: (item) => <RenderItemStatus item={item} />,
  },
  {
    key: 'cfdi_individual',
    title: 'Cfdi indivual',
    dataIndex: 'cfdi_individual',
    render: (item) => <RenderItemResumenStatus item={item.cfdi_individual} />,
  },
  {
    key: 'cfdi_global',
    title: 'Cfdi global',
    dataIndex: 'cfdi_global',
    render: (item) => <RenderItemResumenStatus item={item.cfdi_global} />,
  },
  {
    key: 'cfdi_egreso',
    title: 'Cfdi egreso',
    dataIndex: 'cfdi_egreso',
    render: (item) => <RenderItemResumenStatus item={item.cfdi_egreso} />,
  },
  {
    key: 'cfdi_ingreso',
    title: 'Cfdi ingreso',
    dataIndex: 'cfdi_ingreso',
    render: (item) => <RenderItemResumenStatus item={item.cfdi_ingreso} />,
  },
];

export default AutofacturacionTicketList;
